import React from "react";
import Select from "react-select";

export const PaymentDateFilters = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  billStartDate,
  billEndDate,
  setBillStartDate,
  setBillEndDate,
  applyDateFilter,
}) => {
  return (
    <div className="flex flex-wrap gap-4 items-end justify-start">
      <div>
        <label className="text-xs text-gray-500">
          {setBillStartDate ? "Payment Start Date" : "Start Date"}
        </label>
        <div className="relative">
          <input
            type="date"
            className="w-full border rounded-lg px-3 py-2 mt-1 focus:ring-2 focus:ring-indigo-400 outline-none"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />

          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-black pointer-events-none">
            📅
          </span>
        </div>
      </div>

      <div>
        <label className="text-xs text-gray-500">
          {setBillEndDate ? "Payment End Date" : "End Date"}
        </label>
        <div className="relative">
          <input
            type="date"
            className="w-full border rounded-lg px-3 py-2 mt-1 bg-white text-gray-800 focus:ring-2 focus:ring-indigo-400 outline-none"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-black pointer-events-none">
            📅
          </span>
        </div>
      </div>

      {setBillStartDate && (
        <>
          <div>
            <label className="text-xs text-gray-500">Bill Start Date</label>
            <div className="relative">
              <input
                type="date"
                className="w-full border rounded-lg px-3 py-2 mt-1 bg-white text-gray-800 focus:ring-2 focus:ring-indigo-400 outline-none"
                value={billStartDate}
                onChange={(e) => setBillStartDate(e.target.value)}
              />
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-black pointer-events-none">
                📅
              </span>
            </div>
          </div>

          <div>
            <label className="text-xs text-gray-500">Bill End Date</label>
            <div className="relative">
              <input
                type="date"
                className="w-full border rounded-lg px-3 py-2 mt-1 bg-white text-gray-800 focus:ring-2 focus:ring-indigo-400 outline-none"
                value={billEndDate}
                onChange={(e) => setBillEndDate(e.target.value)}
              />
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-black pointer-events-none">
                📅
              </span>
            </div>
          </div>
        </>
      )}

      <button
        onClick={applyDateFilter}
        className="bg-blue-600 text-white px-4 py-2 rounded h-10"
      >
        Apply
      </button>
    </div>
  );
};

export const PaymentDueFilter = ({ isPaymentDue, onChange }) => {
  return (
    <div>
      <label className="text-xs text-gray-500">Payment Due</label>
      <select
        className="block w-40 border rounded-lg px-3 py-2 mt-1 bg-white text-gray-800 focus:ring-2 focus:ring-indigo-400 outline-none"
        value={String(isPaymentDue)}
        onChange={(e) => {
          const val = e.target.value;
          onChange(val === "all" ? "all" : val === "true");
        }}
      >
        <option value="all">All</option>
        <option value="true">Due</option>
        <option value="false">Not Due</option>
      </select>
    </div>
  );
};

const FilterSelect = ({ label, value, onChange, options }) => (
  <div>
    <label className="text-xs text-gray-500">{label}</label>
    <select
      className="block w-40 border rounded-lg px-3 py-2 mt-1 bg-white text-gray-800 focus:ring-2 focus:ring-indigo-400 outline-none"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
);

export const PaymentBillDateModeFilter = ({ value, onChange }) => (
  <FilterSelect
    label="Without Bill Date"
    value={value}
    onChange={onChange}
    options={[
      { value: "EXCLUDE", label: "Exclude" },
      { value: "INCLUDE", label: "Include" },
      { value: "ONLY_MISSING", label: "Only missing" },
    ]}
  />
);

export const PaymentMethodFilter = ({ value, onChange, methods }) => (
  <FilterSelect
    label="Payment Method"
    value={value}
    onChange={onChange}
    options={[
      { value: "", label: "All" },
      ...methods.map((method) => ({ value: method, label: method })),
    ]}
  />
);

export const PaymentGstFilter = ({ value, onChange }) => (
  <FilterSelect
    label="GST Bill"
    value={value}
    onChange={onChange}
    options={[
      { value: "all", label: "All" },
      { value: "true", label: "GST" },
      { value: "false", label: "Non-GST" },
    ]}
  />
);

export const PaymentPartyFilter = ({
  label,
  allLabel,
  selected,
  onChange,
  options = [],
}) => {
  const allOptions = [{ value: "", label: allLabel }, ...options];

  return (
    <div className="w-56">
      <label className="text-xs text-gray-500 block mb-1">{label}</label>
      <Select
        options={allOptions}
        value={allOptions.find((o) => o.value === selected) || allOptions[0]}
        onChange={(opt) => onChange(opt.value)}
        className="text-sm"
        styles={{
          control: (base) => ({
            ...base,
            borderRadius: "0.5rem",
            minHeight: "42px",
          }),
        }}
      />
    </div>
  );
};
